import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import hasPpsListingsActions from '../actions/hasPpsListings';

// Middleware function
function getHasPpsListings(store) {
    const accountUuid = store.getState().app.accountUuid;

    request.get(`/${config.url_prefix}/api/getHasPpsListings?accountUuid=${accountUuid}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(hasPpsListingsActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    store.dispatch(hasPpsListingsActions.getHasPpsListingsSuccess(!!parsedResponse?.hasPpsListings));
                } catch (exp) {
                    store.dispatch(hasPpsListingsActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getHasPpsListings;
